import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import TemplateVariableChip from '../components/TemplateVariableChip.tsx';
import { TEMPLATE_VARIABLE_ATTR } from '../templateVariableAttrs.ts';

export const TemplateVariable = Node.create({
  name: 'templateVariable',
  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      variable: {
        default: null,
        parseHTML: (element) => element.getAttribute(TEMPLATE_VARIABLE_ATTR),
        renderHTML: (attributes) => ({
          [TEMPLATE_VARIABLE_ATTR]: attributes.variable,
        }),
      },
    };
  },

  parseHTML() {
    return [{ tag: `span[${TEMPLATE_VARIABLE_ATTR}]` }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes), node.attrs.variable ?? ''];
  },

  addNodeView() {
    return ReactNodeViewRenderer(TemplateVariableChip);
  },
});
